var banner_list_main

$(document).ready(function () {
  function _init() {
    cacheDom()
    render()
  }
  function cacheDom() {
    const urlParams = new URLSearchParams(window.location.search);

    // Get the value of a specific parameter, e.g., 'param1'
    const param1Value = urlParams.get('filter');
    console.log(param1Value);
    // $(`.custom-filter-section [data-url$="${param1Value}"]:first`).trigger('click')
    if (param1Value) {
      if (param1Value.includes('hot-products')) {
        $(`.custom-filter-section .hot-selling`).trigger('click')
      } else if (param1Value.includes('new-products')) {
        $(`.custom-filter-section .new-selling`).trigger('click')
      } else {
        $(`.custom-filter-section [href="${param1Value}"]`).trigger('click')
      }
    }
    $(".custom-filter-section .filter-list:has(.filter-active) > span.icon").trigger('click')

    $(".custom-filter-section .filter-list.filter-active > span.icon").trigger('click')
  }
  function render() {

  }


  $(".custom-filter-section .filter-list span.icon").click(function () {
    if ($(this).parent().find('> span.icon').attr("aria-hidden") == "false") {
      $(this).parent().find('> span.icon').attr("aria-hidden", "true")
      $(this).parent().find('> .filter-category').hide()
      $(this).parent().find('> span.icon').css("transform", "rotate(0deg)")
    }
    else {
      $(this).parent().find('> span.icon').attr("aria-hidden", "false")
      $(this).parent().find('> .filter-category').show()
      $(this).parent().find('> span.icon').css("transform", "rotate(180deg)")
    }
  })
  var data_url = ""
  $(".custom-filter-section .filter-list .filter-name").click(function (e) {
    e.preventDefault()
    if ($(this).parent().find('> span.icon').attr("aria-hidden") == "false" && $(this).hasClass('filter-active')) {
      $(this).parent().find('> span.icon').attr("aria-hidden", "true")
      $(this).parent().find('> .filter-category').hide()
      $(this).parent().find('> span.icon').css("transform", "rotate(0deg)")
    }
    else {
      $(this).parent().find('> span.icon').attr("aria-hidden", "false")
      $(this).parent().find('> .filter-category').show()
      $(this).parent().find('> span.icon').css("transform", "rotate(180deg)")
    }


    // $(".custom-filter-section .filter-list .filter-name").not(this).parent().find('> span.icon').attr("aria-hidden","true")
    // $(".custom-filter-section .filter-list .filter-name").not(this).parent().find('> .filter-category').hide()
    // $(".custom-filter-section .filter-list .filter-name").not(this).parent().find('> span.icon').css("transform","rotate(0deg)")


    // $(this).parent().find('> span.icon').attr("aria-hidden","false")
    // $(this).parent().find('> .filter-category').show()
    // $(this).parent().find('> span.icon').css("transform","rotate(180deg)")


    let dataurl = $(this).attr("href")
    if (dataurl != data_url) {
      data_url = dataurl
      loadJSONcollection(dataurl)
    }

    $(".custom-filter-section .custom-filter-nav").hide()
    $(".custom-filter-section .filter-results").show()
    $(".custom-filter-section .filter-name").removeClass("filter-active")
    $(this).addClass("filter-active")
    $(".custom-filter-section .col-2 .filter-results .section-header__title span.sect-title").text($(this).find('> span:first-child').text())


    $(".custom-filter-section .filter-list").each(function (e) {
      // if($(this).find('.filter-active').length > 0){
      //   $(this).find('> span.icon').attr("aria-hidden","false")
      //   $(this).find('> .filter-category').show()
      //   $(this).find('> span.icon').css("transform","rotate(180deg)")
      // }
      if ($(this).find('.filter-active').length == 0) {
        $(this).find('> span.icon').attr("aria-hidden", "true")
        $(this).find('> .filter-category').hide()
        $(this).find('> span.icon').css("transform", "rotate(0deg)")

      }
    })

    $('html, body').animate({
      scrollTop: $("#custom-filter-section").offset().top - 150
    }, 10);


  })

  $(".custom-filter-section .filter-name").click(function () {
    // let dataurl = $(this).attr("data-url")
    // loadJSONcollection(dataurl)
    // $(".custom-filter-section .sliders").hide()
    // $(".custom-filter-section .filter-results").show()
    // $(".custom-filter-section .filter-name").removeClass("filter-active")
    // $(this).addClass("filter-active")
    // $(".custom-filter-section .col-2 .section-header__title span:first-child").text($(this).find('> span:first-child').text())


    //   $(".custom-filter-section .filter-list").each(function(e){
    //     if($(this).find('.filter-active').length > 0){
    //       $(this).find('> span.icon').attr("aria-hidden","false")
    //       $(this).find('> .filter-category').show()
    //       $(this).find('> span.icon').css("transform","rotate(180deg)")
    //     }else{
    //       $(this).parent().find('> span.icon').attr("aria-hidden","true")
    //       $(this).parent().find('> .filter-category').hide()
    //       $(this).parent().find('> span.icon').css("transform","rotate(0deg)")

    //     }
    //   })

    // $('html, body').animate({
    //     scrollTop: $("#custom-filter-section").offset().top - 150
    // }, 10);
  })


  $(".custom-filter-section .new-selling").click(function () {
    $(".custom-filter-section .custom-filter-nav").hide()
    $(".custom-filter-section .filter-new-selling").show()
    $(".custom-filter-section .filter-results").hide()
  })

  $(".custom-filter-section .hot-selling").click(function () {
    $(".custom-filter-section .custom-filter-nav").hide()
    $(".custom-filter-section .filter-hot-selling").show()
    $(".custom-filter-section .filter-results").hide()
  })

  function loadJSONcollection(url) {

    $('.custom-filter-section .pagination-container').pagination({
      pageSize: 8,
      showSizeChanger: true,
      sizeChangerOptions: [8, 12, 16, 20, 24],
      hideOnlyOnePage: true,
      showNavigator: true,
      formatNavigator: '<%= rangeStart %>-<%= rangeEnd %> of <%= totalNumber %> items',
      dataSource: function (done) {
        $.ajax({
          url: `${url}?view=home`,
          type: 'GET'
        })
          .success(function (data) {
            dd = data
            let d = (dd.replaceAll("\t", "")).replaceAll("\n", "")
            done(JSON.parse(d).results)
          })
          .fail(function (data) { console.log(data) })


      },
      callback: function (data, pagination) {
        // template method of yourself
        // var html = template(data);
        template(data);

        // $('.custom-filter-section .product-grid-container').html(html);


        $('.paginationjs-page,.paginationjs-next,.paginationjs-prev').click(function () {
          $('html, body').animate({
            scrollTop: $("#custom-filter-section").offset().top - 150
          }, 10);

        })


        waitForElm('.filter-general-category .filter-main-category .filter-active').then(function () {
          // let collection_handle = $(menu_parent.parent().parents('.filter-list:last').children()[0]).attr('href')
          $('.filter-results').find('.grid-link').attr("href", function (i, href) {
            var href = new URL(window.location.origin + href);

            href.searchParams.set('m', 'category')

            let site_nav_current = $('.filter-general-category .filter-main-category .filter-active')


            href.searchParams.set('index', site_nav_current.parent().attr('data-index'))

            return href.pathname + decodeURIComponent(href.search)
          })
        })
      }
    })

  }

  function template(data) {
    // console.log(data)
    let html_content = ""
    data.forEach(e => {
      html_content += e
    })
    $('.product-grid-container .grid-uniform').html(html_content)
  }

  // start shop by case
  const shop_by_case_list = [
    {
      'img': {
        'desktop': 'https://store.rakwireless.com/cdn/shop/files/usecase1.png?v=1712859608',
      },
      'link': 'https://store.rakwireless.com/products/rak2270-rak-sticker-tracker?utm_source=store_banner&utm_medium=organic&utm_campaign=store_homepage_shop_by_use_case',
    },
    {
      'img': {
        'desktop': 'https://store.rakwireless.com/cdn/shop/files/usecase2.png?v=1712859608',
      },
      'link': 'https://store.rakwireless.com/products/assessment-of-indoor-air-quality-solution-kit?variant=43309760708806?utm_source=store_banner&utm_medium=organic&utm_campaign=store_homepage_shop_by_use_case',
    },
    {
      'img': {
        'desktop': 'https://store.rakwireless.com/cdn/shop/files/usecase3.png?v=1712859608',
      },
      'link': 'https://store.rakwireless.com/products/temperature-and-humidity-sensor-for-condensation-monitoring?variant=43224606539974?utm_source=store_banner&utm_medium=organic&utm_campaign=store_homepage_shop_by_use_case',
    },
  ]

  let shop_by_case_html = ''
  shop_by_case_list.map((banner) => {
    const template = `
      <div class="swiper-slide ${banner.pagination}">
        <div class="shop-by-case-card">
            <a href="${banner.link}">
              <img src="${banner.img.desktop}" class="collection-img">
              <!--<div class="over-img" style="margin-top:16px;">
              <img height="30" src="https://cdn.shopify.com/s/files/1/0177/8784/6756/files/anniv-sale.svg?v=1718353948">
              <img height="30" src="https://cdn.shopify.com/s/files/1/0177/8784/6756/files/free-shipping_1.svg?v=1719810977">
              </div>-->
            </a>
        </div>
      </div>
    `
    shop_by_case_html += template
  })
  $('.shop-by-case-swiper .swiper-wrapper').html(shop_by_case_html)

  const swiperShopByCase = new Swiper('.shop-by-case-swiper', {
    slidesPerView: 2,
    breakpoints: {
      // when window width is >=768px
      769: {
        slidesPerView: 4,
      },
    },
    navigation: {
      nextEl: '.shop-by-case-swiper .swiper-custom-button-next',
      prevEl: '.shop-by-case-swiper .swiper-custom-button-prev',
    }


  })

  // end shop by case

  // ===============================
  // Banner helpers (safe parsing)
  // ===============================
  function getDataArray(selector, attrName) {
    let raw = $(selector).attr(attrName) || "";
    raw = raw.replace(/,\s*$/, ""); // remove trailing ", "
    return raw.split(", "); // ✅ DO NOT filter(Boolean)
  }



  function isBannerActive(startStr, endStr) {
    // If no schedule set, always show banner
    if (!startStr || !endStr) return true;

    try {
      startStr = startStr.trim();
      endStr = endStr.trim();

      // ✅ NEW FORMAT SUPPORT:
      // "2026-01-16 19:34"
      if (startStr.includes("-") && startStr.includes(":")) {
        // Convert to ISO: "2026-01-16T19:34"
        let startDate = new Date(startStr.replace(" ", "T"));
        let endDate = new Date(endStr.replace(" ", "T"));
        let now = new Date();

        // Safety: invalid date = show it
        // if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return true;
        return now.getTime() >= startDate.getTime() && now.getTime() <= endDate.getTime();
      }

      // ✅ OLD FORMAT SUPPORT (your earlier pipe format)
      if (startStr.includes("|") && endStr.includes("|")) {
        let s = startStr.split("|");
        let e = endStr.split("|");

        let start = { day: parseInt(s[0]), month: parseInt(s[1]), year: parseInt(s[2]), time: s[3] };
        let end = { day: parseInt(e[0]), month: parseInt(e[1]), year: parseInt(e[2]), time: e[3] };

        if (typeof isWithinDateTimeRangeInHKT === "function") {
          return isWithinDateTimeRangeInHKT(start, end);
        }
        return true;
      }

      // Unknown format → show banner
      return true;
    } catch (err) {
      console.warn("Invalid banner schedule:", startStr, endStr, err);
      return true;
    }
  }

  async function bannerLinkExists(url) {
    if (!url || url === "#") return true;

    let parsedUrl;
    try {
      parsedUrl = new URL(url, window.location.origin);
    } catch (err) {
      return false;
    }

    // Cross-origin responses cannot be inspected reliably from storefront JS.
    if (parsedUrl.origin !== window.location.origin) return true;

    try {
      let response = await fetch(parsedUrl.href, {
        method: "HEAD",
        credentials: "same-origin",
        redirect: "follow"
      });

      if (response.status === 405) {
        response = await fetch(parsedUrl.href, {
          method: "GET",
          credentials: "same-origin",
          redirect: "follow"
        });
      }

      return response.ok;
    } catch (err) {
      console.warn("Unable to verify banner link:", url, err);
      return false;
    }
  }

  async function filterBannersByLink(banners) {
    const checks = await Promise.all(banners.map(async (banner) => {
      if (!banner.checkLink) return true;
      return bannerLinkExists(banner.link);
    }));

    return banners.filter((banner, index) => checks[index]);
  }

  function renderMainBanners(banners) {
    let banner_html_main = "";
    banners.forEach((banner) => {
      banner_html_main += `
      <div class="swiper-slide ${banner.pagination}">
        <div class="header-banner__card">
          <a href="${banner.link}">
            <img src="${banner.img.desktop}" alt="${banner.alt}">
          </a>
        </div>
      </div>
    `;
    });

    $(".swiper-header .swiper-wrapper").html(banner_html_main);

    if (banners.length > 0) {
      new Swiper(".swiper-header", {
        slidesPerView: 1,
        pagination: {
          el: ".swiper-header .swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          769: { enabled: true },
        },
        enabled: false,
        loop: banners.length > 1,
        autoplay: {
          delay: 5000,
        },
      });
    }
  }

  // ===============================
  // Desktop banner side scheduler
  // ===============================
  Promise.all($(".banner-side-desktop-item").map(function () {
    const banner = $(this);
    const startStr = banner.attr("data-start") || "";
    const endStr = banner.attr("data-end") || "";
    const shouldCheckLink = banner.attr("data-check-link") === "true";

    return Promise.all([
      isBannerActive(startStr, endStr),
      shouldCheckLink ? bannerLinkExists(banner.attr("href")) : true
    ]).then(([isActive, linkExists]) => {
      if (!isActive || !linkExists) banner.remove();
    });
  }).get());



  // ===============================
  // MAIN banner slider (desktop slider)
  // ===============================
  let banner_slider_desktop = getDataArray("#header-banner-data", "data-desktop");
  let banner_slider_mobile = getDataArray("#header-banner-data", "data-mobile");
  let banner_slider_url = getDataArray("#header-banner-data", "data-url");
  let banner_slider_alt = getDataArray("#header-banner-data", "data-alt");
  let banner_slider_pagination = getDataArray("#header-banner-data", "data-pagination");
  let banner_slider_check_link = getDataArray("#header-banner-data", "data-check-link");

  // ✅ NEW schedule arrays
  let banner_slider_start = getDataArray("#header-banner-data", "data-start");
  let banner_slider_end = getDataArray("#header-banner-data", "data-end");

  banner_list_main = banner_slider_desktop.map((b, i) => {
    return {
      img: {
        desktop: banner_slider_desktop[i],
        mobile: banner_slider_mobile[i],
      },
      alt: banner_slider_alt[i] || "",
      link: banner_slider_url[i] || "#",
      pagination: banner_slider_pagination[i] || "",
      start: banner_slider_start[i] || "",
      end: banner_slider_end[i] || "",
      checkLink: banner_slider_check_link[i] === "true",
    };
  });

  // ✅ filter out inactive banners
  banner_list_main = banner_list_main.filter(b => { 
    console.log(b.alt, b.end)
    return isBannerActive(b.start, b.end); });

  // ===============================
  // SIDE banners (mobile swiper / header2)
  // ===============================
  let banner_side_mobile = getDataArray("#banner-side-data", "data-mobile");
  let banner_side_url = getDataArray("#banner-side-data", "data-url");
  let banner_side_alt = getDataArray("#banner-side-data", "data-alt");
  let banner_side_pagination = getDataArray("#banner-side-data", "data-pagination");
  let banner_side_check_link = getDataArray("#banner-side-data", "data-check-link");

  // ✅ NEW schedule arrays
  let banner_side_start = getDataArray("#banner-side-data", "data-start");
  let banner_side_end = getDataArray("#banner-side-data", "data-end");

  let banner_list_side = banner_side_mobile.map((b, i) => {
    return {
      img: { mobile: banner_side_mobile[i] },
      alt: banner_side_alt[i] || "",
      link: banner_side_url[i] || "#",
      pagination: banner_side_pagination[i] || "",
      start: banner_side_start[i] || "",
      end: banner_side_end[i] || "",
      checkLink: banner_side_check_link[i] === "true",
    };
  });

  // ✅ filter inactive
  banner_list_side = banner_list_side.filter(b => isBannerActive(b.start, b.end));

  Promise.all([
    filterBannersByLink(banner_list_main),
    filterBannersByLink(banner_list_side)
  ]).then(([availableMainBanners, availableSideBanners]) => {
    banner_list_main = availableMainBanners;
    banner_list_side = availableSideBanners;
    renderMainBanners(banner_list_main);

    // ✅ combine slider + side banners into 1 swiper (header2)
    let banner_list = [...banner_list_main, ...banner_list_side];

    let banner_html = "";
    banner_list.forEach((banner) => {
      banner_html += `
    <div class="swiper-slide ${banner.pagination}">
      <div class="header-banner__card">
        <a href="${banner.link}">
          <img src="${banner.img.mobile}" alt="${banner.alt}" style="width:100%;border-radius:5px;">
        </a>
      </div>
    </div>
  `;
    });

    $(".swiper-header2 .swiper-wrapper").html(banner_html);

    if (banner_list.length > 0) {
      const swiperHeader2 = new Swiper(".swiper-header2", {
      slidesPerView: 1,
      pagination: {
        el: ".swiper-header2 .swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        769: {
          slidesPerView: 1,
          enabled: false,
        },
      },
      loop: banner_list.length > 1, // ✅ loop only if more than 1 banner
      autoplay: {
        delay: 5000,
      },
      });
    }
  });

  _init();

})